/* Kieszonkowe Inc. — countdown, achievementy, easter egg. Bez zależności, ~3 KB. */
(() => {
  const store = {
    get(key, fallback) {
      try { const v = localStorage.getItem(key); return v === null ? fallback : JSON.parse(v); } catch (e) { return fallback; }
    },
    set(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* tryb prywatny */ } },
  };

  /* Countdown do dropu */
  const pad = (n) => String(n).padStart(2, '0');
  document.querySelectorAll('[data-k-countdown]').forEach((el) => {
    const target = Date.parse(el.dataset.kCountdown);
    if (Number.isNaN(target)) return;
    const parts = { d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'), m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]') };
    const tick = () => {
      const diff = target - Date.now();
      if (diff <= 0) { el.dataset.state = 'live'; return false; }
      const s = Math.floor(diff / 1000);
      parts.d.textContent = pad(Math.floor(s / 86400));
      parts.h.textContent = pad(Math.floor((s % 86400) / 3600));
      parts.m.textContent = pad(Math.floor((s % 3600) / 60));
      parts.s.textContent = pad(s % 60);
      return true;
    };
    if (tick()) { const id = setInterval(() => { if (!tick()) clearInterval(id); }, 1000); }
  });

  /* Achievementy — teksty w języku strony z snippets/k-strings.liquid */
  const S = window.kStrings || {
    unlocked: 'ACHIEVEMENT: ', intranet: ['Kieszonkowe Inc.', ''], analyst: ['Junior Analyst', ''],
    shareholder: ['Shareholder', ''], konami: ['Konami', ''],
  };
  const unlocked = new Set(store.get('k_achievements', []));
  let toast;
  const unlock = (id, title, text) => {
    if (unlocked.has(id)) return;
    unlocked.add(id);
    store.set('k_achievements', [...unlocked]);
    toast = toast || Object.assign(document.createElement('div'), { className: 'k-achievement', role: 'status' });
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML = '';
    const b = document.createElement('b'); b.textContent = S.unlocked + title;
    toast.append(b, document.createTextNode(text));
    document.body.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    setTimeout(() => toast.classList.remove('is-visible'), 4200);
  };

  unlock('intranet', ...S.intranet);

  if (document.body.classList.contains('template-product') || document.querySelector('product-info')) {
    const seen = new Set(store.get('k_seen_products', []));
    seen.add(location.pathname);
    store.set('k_seen_products', [...seen].slice(-50));
    if (seen.size >= 10) unlock('analityk', ...S.analyst);
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[name="add"], .product-form__submit')) unlock('udzialowiec', ...S.shareholder);
  });

  /* Easter egg: kod Konami */
  const konami = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'];
  let pos = 0;
  document.addEventListener('keydown', (e) => {
    pos = e.key === konami[pos] ? pos + 1 : (e.key === konami[0] ? 1 : 0);
    if (pos === konami.length) {
      pos = 0;
      unlock('konami', ...S.konami);
      const secret = document.body.dataset.kSecretUrl;
      if (secret) setTimeout(() => { location.href = secret; }, 1500);
    }
  });
})();
